// // import React, { useState, forwardRef } from "react";
// // import DatePicker from "react-datepicker";
// // import "react-datepicker/dist/react-datepicker.css";
// // import "./datePicker.css";

// // const Datepicker = ({
// //   name,
// //   placeHolder,
// //   value,
// //   required,
// //   onChange,
// //   index,
// //   minDate,
// //   maxDate,
// // }) => {
// //   const [viewMode, setViewMode] = useState("day");
// //   const [date, setDate] = useState(value);
// //   const [isOpen, setIsOpen] = useState(false);

// //   // Custom input component
// //   const CustomInput = forwardRef(({ placeHolder, value }, ref) => (
// //     <div
// //       className="custom-datepicker element-style"
// //       onClick={() => setIsOpen(true)}
// //       ref={ref}
// //     >
// //       <input
// //         type="text"
// //         value={value || ""}
// //         readOnly
// //         placeholder={placeHolder}
// //         required={required}
// //       />
// //       <span className={`dropdown-icon ${isOpen ? "rotate" : ""}`}>
// //         <i
// //           className="bi bi-chevron-down"
// //           size={16}
// //           style={{ color: "#525658" }}
// //         ></i>
// //       </span>
// //     </div>
// //   ));

// //   const handleHeaderClick = () => {
// //     if (viewMode === "day") setViewMode("month");
// //     else if (viewMode === "month") setViewMode("year");
// //   };

// //   const handleDateChange = (selectedDate) => {
// //     setDate(selectedDate);
// //     onChange(name, selectedDate, index);

// //     if (viewMode === "year") setViewMode("month");
// //     else if (viewMode === "month") setViewMode("day");
// //     else setIsOpen(false);
// //   };

// //   return (
// //     <div>
// //       <DatePicker
// //         selected={date}
// //         onChange={handleDateChange}
// //         dateFormat="dd/MM/yyyy"
// //         customInput={<CustomInput placeHolder={placeHolder} value={date} />}
// //         showMonthYearPicker={viewMode === "month"}
// //         showYearPicker={viewMode === "year"}
// //         open={isOpen}
// //         onClickOutside={() => setIsOpen(false)}
// //         {...(minDate && { minDate })}
// //         {...(maxDate && { maxDate })}
// //         renderCustomHeader={({
// //           date,
// //           decreaseMonth,
// //           increaseMonth,
// //           decreaseYear,
// //           increaseYear,
// //         }) => (
// //           <div className="react-datepicker__custom-header">
// //             {viewMode === "day" && (
// //               <div onClick={handleHeaderClick}>
// //                 {date.toLocaleDateString("en-US", {
// //                   month: "long",
// //                   year: "numeric",
// //                 })}
// //               </div>
// //             )}
// //             {["month", "year"].includes(viewMode) && (
// //               <div className="header-controls">
// //                 <button
// //                   type="button"
// //                   className="btn btn-sm h-btn"
// //                   onClick={decreaseYear}
// //                 >
// //                   {"<<"}
// //                 </button>
// //                 <span onClick={handleHeaderClick}>{date.getFullYear()}</span>
// //                 <button
// //                   type="button"
// //                   className="btn btn-sm h-btn"
// //                   onClick={increaseYear}
// //                 >
// //                   {">>"}
// //                 </button>
// //               </div>
// //             )}
// //           </div>
// //         )}
// //       />
// //     </div>
// //   );
// // };

// // export default Datepicker;

// import React, { useState, useEffect, forwardRef } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import "./datePicker.css";

// const Datepicker = ({
//   name,
//   placeHolder,
//   value,
//   required,
//   onChange,
//   index,
//   minDate,
//   maxDate,
// }) => {
//   const [viewMode, setViewMode] = useState("day");
//   const [date, setDate] = useState(value);
//   const [isOpen, setIsOpen] = useState(false);
//   const [inputValue, setInputValue] = useState("");

//   // Format date as dd/MM/yyyy
//   function formatDate(date) {
//     if (!date) return "";
//     const d = new Date(date);
//     const day = String(d.getDate()).padStart(2, "0");
//     const month = String(d.getMonth() + 1).padStart(2, "0");
//     const year = d.getFullYear();
//     return `${day}/${month}/${year}`;
//   }

//   // Initialize inputValue when value prop changes
//   useEffect(() => {
//     setInputValue(value ? formatDate(value) : "");
//     setDate(value);
//   }, [value]);

//   // Parse dd/MM/yyyy string to Date
//   function parseDate(dateString) {
//     const parts = dateString.split("/");
//     if (parts.length === 3) {
//       const day = parseInt(parts[0], 10);
//       const month = parseInt(parts[1], 10) - 1;
//       const year = parseInt(parts[2], 10);
      
//       if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
      
//       const parsedDate = new Date(year, month, day);
      
//       // Validate the date
//       if (
//         parsedDate.getDate() === day &&
//         parsedDate.getMonth() === month &&
//         parsedDate.getFullYear() === year
//       ) {
//         return parsedDate;
//       }
//     }
//     return null;
//   }

//   const handleInputChange = (e) => {
//     let value = e.target.value;
    
//     // Remove non-numeric characters except /
//     value = value.replace(/[^\d/]/g, "");
    
//     // Limit to 10 characters
//     if (value.length > 10) return;
    
//     // Auto-add slashes
//     const prevLength = inputValue.length;
//     if (value.length === 2 && prevLength === 1 && !value.includes("/")) {
//       value += "/";
//     } else if (value.length === 5 && prevLength === 4 && value.split("/").length === 2) {
//       value += "/";
//     }
    
//     setInputValue(value);
    
//     // Try to parse and set date if valid format (dd/MM/yyyy)
//     if (value.length === 10) {
//       const parsedDate = parseDate(value);
//       if (parsedDate && !isNaN(parsedDate.getTime())) {
//         // Check if date is within min/max range
//         if (minDate && parsedDate < minDate) {
//           return;
//         }
//         if (maxDate && parsedDate > maxDate) {
//           return;
//         }
        
//         setDate(parsedDate);
//         onChange(name, parsedDate, index);
//       }
//     }
//   };

//   const handleInputBlur = () => {
//     // If input is incomplete or invalid, reset to last valid date
//     if (inputValue.length > 0 && inputValue.length < 10) {
//       setInputValue(date ? formatDate(date) : "");
//     } else if (inputValue.length === 10) {
//       const parsedDate = parseDate(inputValue);
//       if (!parsedDate || isNaN(parsedDate.getTime())) {
//         setInputValue(date ? formatDate(date) : "");
//       }
//     }
//   };

//   // Custom input component
//   const CustomInput = forwardRef(({ placeHolder }, ref) => (
//     <div className="custom-datepicker element-style" ref={ref}>
//       <input
//         type="text"
//         value={inputValue}
//         onChange={handleInputChange}
//         onBlur={handleInputBlur}
//         onFocus={() => setIsOpen(true)}
//         placeholder={placeHolder}
//         required={required}
//       />
//       <span
//         className={`dropdown-icon ${isOpen ? "rotate" : ""}`}
//         onClick={(e) => {
//           e.stopPropagation();
//           setIsOpen(!isOpen);
//         }}
//       >
//         <i
//           className="bi bi-chevron-down"
//           size={16}
//           style={{ color: "#525658" }}
//         ></i>
//       </span>
//     </div>
//   ));

//   const handleHeaderClick = () => {
//     if (viewMode === "day") setViewMode("month");
//     else if (viewMode === "month") setViewMode("year");
//   };

//   const handleDateChange = (selectedDate) => {
//     setDate(selectedDate);
//     setInputValue(formatDate(selectedDate));
//     onChange(name, selectedDate, index);

//     if (viewMode === "year") setViewMode("month");
//     else if (viewMode === "month") setViewMode("day");
//     else setIsOpen(false);
//   };

//   return (
//     <div>
//       <DatePicker
//         selected={date}
//         onChange={handleDateChange}
//         dateFormat="dd/MM/yyyy"
//         customInput={<CustomInput placeHolder={placeHolder} />}
//         showMonthYearPicker={viewMode === "month"}
//         showYearPicker={viewMode === "year"}
//         open={isOpen}
//         onClickOutside={() => setIsOpen(false)}
//         {...(minDate && { minDate })}
//         {...(maxDate && { maxDate })}
//         renderCustomHeader={({
//           date,
//           decreaseMonth,
//           increaseMonth,
//           decreaseYear,
//           increaseYear,
//         }) => (
//           <div className="react-datepicker__custom-header">
//             {viewMode === "day" && (
//               <div onClick={handleHeaderClick}>
//                 {date.toLocaleDateString("en-US", {
//                   month: "long",
//                   year: "numeric",
//                 })}
//               </div>
//             )}
//             {["month", "year"].includes(viewMode) && (
//               <div className="header-controls">
//                 <button
//                   type="button"
//                   className="btn btn-sm h-btn"
//                   onClick={decreaseYear}
//                 >
//                   {"<<"}
//                 </button>
//                 <span onClick={handleHeaderClick}>{date.getFullYear()}</span>
//                 <button
//                   type="button"
//                   className="btn btn-sm h-btn"
//                   onClick={increaseYear}
//                 >
//                   {">>"}
//                 </button>
//               </div>
//             )}
//           </div>
//         )}
//       />
//     </div>
//   );
// };

// export default Datepicker;

import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./datePicker.css";

const Datepicker = ({
  name,
  placeHolder,
  value,
  required,
  onChange,
  index,
  minDate,
  maxDate,
}) => {
  const [viewMode, setViewMode] = useState("day");
  const [date, setDate] = useState(value);
  const [isOpen, setIsOpen] = useState(false);
  const datePickerRef = useRef(null);

  useEffect(() => {
    setDate(value);
  }, [value]);

  const handleHeaderClick = () => {
    if (viewMode === "day") setViewMode("month");
    else if (viewMode === "month") setViewMode("year");
  };

  const handleDateChange = (selectedDate) => {
    setDate(selectedDate);
    onChange(name, selectedDate, index);

    if (viewMode === "year") setViewMode("month");
    else if (viewMode === "month") setViewMode("day");
    else setIsOpen(false);
  };

  const handleCalendarOpen = () => {
    setIsOpen(true);
  };

  const handleCalendarClose = () => {
    setIsOpen(false);
  };

  const handleIconClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  return (
    <div className="custom-datepicker-wrapper element-style">
      <DatePicker
        ref={datePickerRef}
        selected={date}
        onChange={handleDateChange}
        dateFormat="dd/MM/yyyy"
        placeholderText={placeHolder}
        required={required}
        showMonthYearPicker={viewMode === "month"}
        showYearPicker={viewMode === "year"}
        open={isOpen}
        onInputClick={handleCalendarOpen}
        onClickOutside={handleCalendarClose}
        className="datepicker-input"
        {...(minDate && { minDate })}
        {...(maxDate && { maxDate })}
        renderCustomHeader={({
          date,
          decreaseMonth,
          increaseMonth,
          decreaseYear,
          increaseYear,
        }) => (
          <div className="react-datepicker__custom-header">
            {viewMode === "day" && (
              <div onClick={handleHeaderClick}>
                {date.toLocaleDateString("en-US", {
                  month: "long",
                  year: "numeric",
                })}
              </div>
            )}
            {["month", "year"].includes(viewMode) && (
              <div className="header-controls">
                <button
                  type="button"
                  className="btn btn-sm h-btn"
                  onClick={decreaseYear}
                >
                  {"<<"}
                </button>
                <span onClick={handleHeaderClick}>{date.getFullYear()}</span>
                <button
                  type="button"
                  className="btn btn-sm h-btn"
                  onClick={increaseYear}
                >
                  {">>"}
                </button>
              </div>
            )}
          </div>
        )}
      />
      <span
        className={`dropdown-icon ${isOpen ? "rotate" : ""}`}
        onClick={handleIconClick}
      >
        <i
          className="bi bi-chevron-down"
          style={{ color: "#525658" }}
        ></i>
      </span>
    </div>
  );
};

export default Datepicker;